import { track } from 'utils/trackingUtils'

export const logImpression = ({ impression: { feature, treatment } }) => {
  track('Experiment Viewed', {
    experimentName: feature,
    variationName: treatment,
    source: 'split',
  })
}


// WEBPACK FOOTER //
// ./src/utils/experiments.js